"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartSummaryAdmissionAndPriceMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class CartSummaryAdmissionAndPriceMapper {
    toDomain(result) {
        const error = lodash_1.default.get(result, "data.error");
        const id = lodash_1.default.get(result, "data.orderAdmissionAndPrice.id");
        const order = lodash_1.default.get(result, "data.orderAdmissionAndPrice.quotationComplete");
        return {
            error,
            order: Object.assign(Object.assign({}, order), { id }),
        };
    }
}
exports.CartSummaryAdmissionAndPriceMapper = CartSummaryAdmissionAndPriceMapper;
